import fclone from 'fclone';
export function cloneDeep(value) {
    return fclone(value);
}
//# sourceMappingURL=cloneDeep.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-utilities/lib/util/cloneDeep.js
// module id = 682
// module chunks = 0